import storage from 'helpers/storage';
import getLocale from 'helpers/getLocale';
import { localeToFlagAlpha2 } from 'helpers/flags';

// Helper to validate country code (2-letter or 'int' for international)
const isValidCountryCode = (code) => {
  if (!code) return false;
  const lower = code.toLowerCase();
  return /^[a-z]{2}$/i.test(lower) || lower === 'int';
};

const getCountry = () => {
  try {
    const stored = storage.getItem('country');
    if (stored && isValidCountryCode(stored)) {
      return stored.toLowerCase();
    }
  } catch (_) {}

  try {
    const first = window.location.pathname.split('/').filter(Boolean)[0] || '';
    if (first.includes('-')) {
      const [, countryPart] = first.split('-');
      if (countryPart && isValidCountryCode(countryPart)) {
        return countryPart.toLowerCase();
      }
    } else {
      const segments = window.location.pathname.split('/').filter(Boolean);
      if (segments.length >= 2) {
        const maybeCountry = segments[1];
        if (isValidCountryCode(maybeCountry)) {
          return maybeCountry.toLowerCase();
        }
      }
    }
  } catch (_) {}
  
  const locale = getLocale();
  const code = localeToFlagAlpha2(locale);
  return code && code !== 'un' ? code : '';
};

export default getCountry;
